export default "__VITE_ASSET__DWrNjIjU__"